/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EConflictDialogResult {
  Manage = 'manage',
  Cancel = 'cancel'
}
